import "@/App.css";
import Reservation from "./components/Reservation";

function App() {
  return (
    <div className="App min-h-screen bg-white" data-testid="app-root">
      <Reservation />
    </div>
  );
}

export default App;
